import React, { useEffect } from "react";
import { css } from '@emotion/react';
import { PageProps } from 'gatsby';
import { Layout } from '@/components/general/Layout';
import { Seo } from '@/components/general/Seo';
import { HeroSection } from '@/components/top-page/HeroSection';
import { ImplementSection } from '@/components/top-page/ImplementSection';
import { TaskSupportSection } from '@/components/top-page/TaskSupportSection';
import { TaskSituationSection } from '@/components/top-page/TaskSituationSection';
import { PhaseInfoSection } from '@/components/top-page/PhaseInfoSection';
import { WhatsUniforceSection } from '@/components/top-page/WhatsUniforceSection';
import { CollaboratorSection } from '@/components/top-page/CollaboratorSection';
// import { ExpertsSection } from '@/components/top-page/ExpertsSection';
import { PlanSection } from '@/components/top-page/PlanSection';
import { FaqSection } from '@/components/top-page/FaqSection';
import { NewsSection } from '@/components/top-page/NewsSection';
import { RealitySection } from '@/components/top-page/RealitySection';
import { ContactSection } from '@/components/general/ContactSection';
import { getScreen } from '@/styles/media-query';

const Page: React.FC<PageProps> = ({ location }) => {
  
  useEffect(() => {
    
    const checkAnchor = () => {
      const hash = window.location.hash;
      const offset = 0;
      
      if (hash) {
        const element = document.querySelector(hash);
        if (element) {
          const elementPosition = element.getBoundingClientRect().top + window.pageYOffset - offset;
          window.scrollTo({
              top: elementPosition,
              behavior: 'smooth'
          });
        }else{
          setTimeout(checkAnchor, 100);
        }
      }
    }
    checkAnchor();
    
  }, []);
  
  
  return (
  <Layout location={location}>
    <Seo templateTitle="Uniforce（ユニフォース）IPO準備クラウド"
      title="IPO準備クラウド｜効率的なIPO準備管理ツール｜Uniforce"
      description="IPO準備とガバナンス構築に特化した経営基盤強化のためのクラウドサービス。公認会計士監修の管理ツールで上場までの道のりを徹底伴走支援。スタートアップ・成長企業向けに、IPO準備の効率化とコスト削減を実現。無料相談受け付け中。"
     />
    <div>
      <HeroSection />
      <TaskSituationSection />
      <ContactSection
        css={css`
          margin-top: -63px;
          padding-bottom: 50px;
          
          @media ${getScreen('pc')} {
            margin-top: -192px;
            
            padding-top: 200px;
            padding-bottom: 140px;
          }
        `}
        title1=""
        title2={
          <>
            IPOもM&Aも、
            <br
              css={css`
                @media ${getScreen('pc')} {
                  display: none;
                }
              `}
            />
            IPO準備クラウドで。
          </>
        }
        title3=""
        title4={
          <>
            <span
              css={css`
                display: block;
                margin-top: 20px;
                @media ${getScreen('pc')} {
                  margin-top: 0px;
                }
              `}
            >CEOやCFOなどの経営層から<br
              css={css`
                @media ${getScreen('pc')} {
                  display: none;
                }
              `}
            />実務担当の方にも嬉しい、<br
              css={css`
                @media ${getScreen('pc')} {
                  display: none;
                }
              `}
            />サービスの特徴をご紹介します！</span>
          </>
        }
        text=""
        rounded
        button
      />
      <TaskSupportSection />
      <WhatsUniforceSection />
      <CollaboratorSection />
      <ContactSection
        css={css`
          margin-top: -63px;

          @media ${getScreen('pc')} {
            margin-top: -192px;
          }
        `}
        title1="Uniforce IPO準備クラウドがあれば"
        title2={
          <>
            <span
              css={css`
                @media ${getScreen('pc', '未満')} {
                  display: none;
                }
              `}
            >
            </span>
            IPO・M&A 経験がある
            <br
              css={css`
                @media ${getScreen('pc')} {
                  display: none;
                }
              `}
            />
            管理責任者がいなくても
            <span
              css={css`
                @media ${getScreen('pc', '未満')} {
                  display: none;
                }
              `}
            >
            </span>
          </>
        }
        title3=""
        title4="IPO準備を進められます。"
        text="IPO準備クラウドの機能詳細や無料デモをご希望の方はこちら"
        rounded
      />
      <RealitySection />
      <ContactSection
        css={css`
          margin-top: -63px;

          @media ${getScreen('pc')} {
            margin-top: -192px;
          }
        `}
        title1="Uniforce IPO準備クラウドなら"
        title2="あなたの挑戦を足元から支えるガバナンス構築"
        title3="で"
        title4="経営基盤を強化できます。"
        text=" IPO準備クラウドがもたらす効果を知りたい方はこちら"
        rounded
      />
      <PhaseInfoSection />
      <PlanSection />
      <FaqSection />
      <NewsSection />
      <ImplementSection setPosition="bottom" />
      <ContactSection
        title1="Uniforce IPO準備クラウドなら"
        title2="あなたの挑戦を足元から支えるガバナンス構築"
        title3="で"
        title4="経営基盤を強化できます。"
        text="IPO準備クラウドの機能詳細や無料デモをご希望の方はこちら"
      />
    </div>
  </Layout>
  );
}

export default Page;
